import Alpine from "alpinejs";
Alpine.data("peopleteaser", (uri, fallback = "[]") => ({
    marginY: 7,
    paddingUnits: 3,
    imageUnits: 5,

    // space for iPhone screen so they can generate
    unit: 28,
    maxUnits: 28,
    wrapperUnits: 22,
    spaceLeftUnits: 6,
    heightUnits: 21,

    dots: [],

    timer: null,

    heads: [],
    headIndex: 0,

    dotInst: {
        ["x-transition:leave.duration.100ms"]: "dot-leave",
        ["x-transition:leave-start"]: "dot-leave-start",
        ["x-transition:leave-end"]: "dot-leave-end",
    },
    async init() {
        await this.headhunter();
        for (let i = 0; i < 4; i++) {
            this.dots.push(this.newDot(this.regeneratePosition()));
        }
        this.resize(null, true);
        setTimeout(() => {
            this.dots.filter((dot) => !dot.show && !dot.remove).forEach((dot) => (dot.show = true));
        }, 100);
        this.timer = setInterval(() => {
            this.dots.filter((dot) => dot.remove).forEach((dot) => this.dots.splice(this.dots.indexOf(dot), 1));
            const removeCount = Math.round(Math.random()) + 1;
            const addCount = Math.round(Math.random()) + 1;
            for (let i = 0; i < removeCount; i++) {
                this.dots[i].show = false;
                this.dots[i].remove = true;
            }
            for (let i = 0; i < Math.min(addCount); i++) {
                this.dots.push(this.newDot(this.regeneratePosition()));
            }
            if (this.dots.filter((dot) => !dot.remove).length > 5) {
                this.dots[removeCount + 1].show = false;
                this.dots[removeCount + 1].remove = true;
            }
            if (this.dots.filter((dot) => !dot.remove).length < 4) {
                this.dots.push(this.newDot(this.regeneratePosition()));
            }
            this.$nextTick(() => {
                this.dots.filter((dot) => !dot.show && !dot.remove).forEach((dot) => (dot.show = true));
            });
        }, 2400);
    },
    async headhunter() {
        if (uri === "") {
            this.heads = JSON.parse(fallback);
        } else {
            try {
                const response = await fetch(uri);

                this.heads = await response.json();

                this.heads.sort(() => Math.random() - 0.5);
            } catch (e) {
                console.log(e);
            }
        }
    },
    newDot({ x = -5, y = -5 } = { x: -5, y: -5 }) {
        return {
            x,
            y,
            get vars() {
                return { "--dx": this.x, "--dy": this.y };
            },
            show: false,
            image: this.randomImage(),
        };
    },
    randomImage() {
        if (this.heads.length === 0) {
            // show logo as a fallback
            return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-3 -3 21 21' %3E%3Cpath fill='%23fff' d='M15 10H5V0h10v10ZM3 10H0V7h3v3Zm-3 5h3v-3H0v3Zm8 0H5v-3h3v3Z' clip-rule='evenodd'/%3E%3C/svg%3E";
        }
        return this.heads[this.headIndex++ % this.heads.length];
    },
    regeneratePosition() {
        for (let tries = 0; tries < 100; tries++) {
            const x = this.randomPlacementX();
            const y = this.randomPlacementY();
            const overlap = this.dotsOverlap(x, y);
            const textOverlap = this.overlapsText(x, y);
            if (!overlap && !textOverlap) {
                return { x, y };
            }
        }
        return { x: -5, y: -5 };
    },
    organizeDots() {
        for (let i = 0; i < this.dots.length; i++) {
            const dot = this.dots.splice(0, 1)[0];
            const { x, y } = this.regeneratePosition();
            dot.x = x;
            dot.y = y;
            this.dots.push(dot);
        }
    },
    cleanDots() {
        for (let i = 0; i < this.dots.length; i++) {
            const dot = this.dots[i];
            if (this.overlapsText(dot.x, dot.y, 1) || this.dotOutsideWrapper(dot.x, dot.y)) {
                const { x, y } = this.regeneratePosition();
                dot.x = x;
                dot.y = y;
            }
        }
    },
    dotOutsideWrapper(x, y) {
        return x > this.wrapperUnits + this.spaceLeftUnits || y > this.heightUnits + 1 + this.paddingUnits - 1;
    },
    dotsOverlap(x, y) {
        return this.dots.some((dot) => {
            return (
                dot.x + this.imageUnits > x &&
                dot.x - this.imageUnits < x &&
                dot.y + this.imageUnits > y &&
                dot.y - this.imageUnits < y
            );
        });
    },
    dotsSameLine(x, y) {
        return this.dots.some((dot) => {
            return (
                dot.x === x ||
                dot.y === y ||
                (Math.random() > 0.5 && (dot.x === x + 1 || dot.y === y + 1 || dot.x === x - 1 || dot.y === y - 1))
            );
        });
    },
    overlapsText(x, y, sameline = 0.3) {
        const inSafeArea =
            y <= this.marginY - this.paddingUnits || y >= this.heightUnits + 3 * this.paddingUnits - this.marginY;
        if (inSafeArea) {
            // Make it less random to avoid dots on the same line
            return Math.random() > sameline ? this.dotsSameLine(x, y) : false;
        } else {
            // Spare out the text block
            const rightSpaceUnits = Math.floor(this.$refs.text.offsetWidth / this.unit);
            return !(
                this.wrapperUnits - rightSpaceUnits >= this.imageUnits && x > this.spaceLeftUnits + rightSpaceUnits
            );
        }
    },
    /**
     * @returns {number}
     */
    randomPlacementX() {
        return Math.round(Math.random() * this.wrapperUnits) + this.spaceLeftUnits;
    },
    /**
     * @returns {number}
     */
    randomPlacementY() {
        return Math.round(Math.random() * (this.heightUnits + 1)) + this.paddingUnits - 1;
    },
    resize(event, regenerate = false) {
        this.$nextTick(() => {
            this.unit = this.$refs.unit.offsetWidth;
            this.heightUnits = Math.floor(this.$el.offsetHeight / this.unit) - 2 * this.paddingUnits;
            this.wrapperUnits = Math.floor(this.$refs.wrapper.offsetWidth / this.unit) - 2 * this.paddingUnits;
            this.spaceLeftUnits =
                Math.floor(this.$refs.wrapper.offsetLeft / this.unit) +
                (this.$refs.wrapper.offsetLeft % this.unit === 0 ? 1 : 0) +
                this.paddingUnits;
            this.maxUnits = this.wrapperUnits + this.spaceLeftUnits;
            regenerate ? this.organizeDots() : this.cleanDots();
        });
    },
}));
